import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { EditIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/add-store')({
  component: RouteComponent,
  loader: () => {
    return {
      title: <Translation id="storeManagement.basicStores.manageStoreInfo" />,
      crumb: (
        <CrumbTitle title="Manage Store Information" id="storeManagement.basicStores.manageStoreInfo" icon={EditIcon} />
      ),
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
